import { filter, map, tap, withLatestFrom } from 'rxjs';
import {
  collectRoutines,
  dispatchAction,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import {
  changePresentationContext,
  loadPresentation,
  type LoadPresentationPayload,
} from 'presentation/actions';
import {
  loadedPresentation$,
  type LoadedPresentationState,
} from 'presentation/streams/loadedPresentation$';
import { slideNavigator$ } from 'presentation/slideNavigator/slideNavigator$';
import type { SlideNavigatorState } from 'presentation/slideNavigator/types';

export const toReloadPayload = (
  contextComponentId: ArdoqId | null,
  {
    loadedPresentationId,
    loadedSlideId,
    organizationLabel,
    isCustomDomain,
  }: LoadedPresentationState,
  { selectedSlideId }: SlideNavigatorState
): LoadPresentationPayload | null =>
  loadedPresentationId
    ? {
        presentationId: loadedPresentationId,
        organizationLabel,
        isCustomDomain,
        selectedSlideId: selectedSlideId || loadedSlideId,
        contextComponentId,
      }
    : null;

const handleChangePresentationContext = routine(
  ofType(changePresentationContext),
  extractPayload(),
  withLatestFrom(loadedPresentation$, slideNavigator$),
  map(([contextComponentId, loaded, slideNavigator]) =>
    toReloadPayload(contextComponentId, loaded, slideNavigator)
  ),
  filter(isTruthy),
  tap(payload => dispatchAction(loadPresentation(payload)))
);

export const contextSwitchRoutines = collectRoutines(
  handleChangePresentationContext
);
